<template>
  <v-card>
    <v-card-text class="mt-0 pt-3">
      Loading...
      <v-progress-linear
          indeterminate
          color="primary"
          class="mb-0"
      ></v-progress-linear>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  name: 'DialogLoading',
};
</script>
